import React from 'react';
import pirateDictionary from './pirateDictionary';

interface PirateTextProps {
    text: string;
}

const PirateText: React.FC<PirateTextProps> = ({ text }) => {
    if (!text) return null;

    // Create a regex pattern to match pirate slang words
    // Using word boundaries to ensure we match whole words only
    const slangWords = pirateDictionary.map(item => item.slang);
    const slangPattern = new RegExp(`\\b(${slangWords.join('|')})\\b`, 'gi');

    // Split the text by pirate slang words and create an array of segments
    const segments = [];
    let lastIndex = 0;
    let match;

    while ((match = slangPattern.exec(text)) !== null) {
        // Add non-matching text before the current match
        if (match.index > lastIndex) {
            segments.push({
                text: text.substring(lastIndex, match.index),
                isPirateSlang: false
            });
        }

        // Add the matching pirate slang word
        const slangWord = match[0];
        const slangInfo = pirateDictionary.find(
            item => item.slang.toLowerCase() === slangWord.toLowerCase()
        );

        segments.push({
            text: slangWord,
            isPirateSlang: true,
            meaning: slangInfo?.meaning
        });

        lastIndex = match.index + slangWord.length;
    }

    // Add any remaining text after the last match
    if (lastIndex < text.length) {
        segments.push({
            text: text.substring(lastIndex),
            isPirateSlang: false
        });
    }

    return (
        <span className="pirate-text">
            {segments.map((segment, index) => (
                segment.isPirateSlang ? (
                    <span
                        key={index}
                        className="pirate-slang-highlight"
                        title={segment.meaning}
                    >
                        {segment.text}
                    </span>
                ) : (
                    <span key={index}>{segment.text}</span>
                )
            ))}
        </span>
    );
};

export default PirateText;
